import { createSignal } from "solid-js";
import { api, apiVoid, ApiError } from "../lib/api";
import type { OceanUser } from "./authStore";

const [members, setMembers] = createSignal<OceanUser[]>([]);
const [loading, setLoading] = createSignal(false);
const [error, setError] = createSignal<string | null>(null);

export function useMembers() {
  return members;
}

export function useMembersLoading() {
  return loading;
}

export function useMembersError() {
  return error;
}

export async function loadMembers(orgId: string) {
  setLoading(true);
  setError(null);
  try {
    const list = await api<OceanUser[]>(`/orgs/${orgId}/members`);
    setMembers(list);
  } catch (e) {
    setMembers([]);
    setError(e instanceof ApiError ? e.message : "Failed to load members");
  } finally {
    setLoading(false);
  }
}

export async function inviteMember(orgId: string, email: string, role: string) {
  const created = await api<OceanUser>(`/orgs/${orgId}/invite`, {
    method: "POST",
    body: JSON.stringify({ email, role }),
  });
  setMembers([...members(), created]);
}

export async function updateMemberRole(orgId: string, userId: string, role: string) {
  await apiVoid(`/orgs/${orgId}/members/${userId}/role`, {
    method: "PUT",
    body: JSON.stringify({ role }),
  });
  setMembers(members().map((m) => (m.id === userId ? { ...m, role } : m)));
}

export async function removeMember(orgId: string, userId: string) {
  await apiVoid(`/orgs/${orgId}/members/${userId}`, { method: "DELETE" });
  setMembers(members().filter((m) => m.id !== userId));
}
